import { FC } from "react";

interface SpinnerProps {
  size?: "sm" | "md" | "lg";
}

const Spinner: FC<SpinnerProps> = ({ size }) => {
  const classes = () => {
    switch (size) {
      case "sm":
        return "tw-h-6 tw-w-6";
      case "md":
        return "tw-h-10 tw-w-10";
      case "lg":
        return "tw-h-14 tw-w-14";
      default:
        return "tw-h-8 tw-w-8";
    }
  };
  return (
    <div
      className={`${classes()} tw-border-2 tw-border-tr tw-border-solid tw-rounded-full tw-border-t-transparent tw-animate-spin`}
    ></div>
  );
};

export default Spinner;
